export enum CrossSellPage {
    ThankYouPage,
    DeclinePage,
    MemberPortalDashboard,
}